import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StageService } from '../../services/stage-modal.service';
import { StageDuplicationModel } from '../../../../../models/formation/formation.model';
import { BObjectModel, BreadcrumbModel, ComboBox, InputModel, QResult, QueovalBase, QueovalParam } from '../../../../../models';
import { CoreService } from '../../../../../services/core.service';
import { HttpService } from '../../../../../services/dataAccess.service';
import { BreadcrumbService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'queoval-stage-duplication',
  templateUrl: './duplication.component.html',
  styleUrls: ['./duplication.component.css'],
})

export class StageDuplicationComponent implements OnInit {

  @Input('StageIdent') set SetIdent(value: string) {
    if (value && value != '0') {
      this.idBo = value;
      this.idBoSource = value;
      this.modelDuplication.IdentOldStage = value;
      this.http.getHttp<QResult<Array<InputModel>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/GET_DEFAULT_VALUES_FOR_DUPLICATE_STAGE/${value}`).subscribe((result: QResult<Array<InputModel>>) => {

        this.ParamBOStage = new QueovalParam();
        this.ParamBOStage.model = new BObjectModel();
        this.ParamBOStage.model.IdDonneeFils = '0';
        this.ParamBOStage.model.IdDonneePere = '1348';
        this.ParamBOStage.model.IdentBO = 'BO_STAGE';
        this.ParamBOStage.model.IdRelation = 'REL_BO_CENT_BO_STAGE';
        this.ParamBOStage.model.ShowSaveButton = false;
        (this.ParamBOStage.model as BObjectModel).DefaultInputs = result.Value;
        this.defaulInputs = result.Value;
      });

      // Liste des données à dupliquer
      this.http.getHttp<QResult<Array<ComboBox>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/GET_CHECKBOXES_TO_DUPLICATE/${value}`).subscribe((result: QResult<Array<ComboBox>>) => {
        this.checkBoxes = result.Value;
      });

      // Liste des stages non clôturés avec le même code produit ou code action et même type
      this.http.getHttp<QResult<Array<ComboBox>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/GET_STAGES_MEME_PRODUIT/${value}`).subscribe((result: QResult<Array<ComboBox>>) => {
        this.stages = result.Value;
      });
    }
  }

  @Output('success') success: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  constructor(
    public StageService: StageService,
    private indParam: CoreService,
    private http: HttpService,   
    private toast: ToastService,
    private breadCrumb: BreadcrumbService,
    private modalService: NgbModal,
  ) { }

  public ParamBOStage: QueovalParam;
  public checkBoxes: Array<ComboBox>
  public stages: Array<ComboBox>
  public fusionStage: string = '';
  public modelDuplication: StageDuplicationModel = new StageDuplicationModel();
  public saveBO: boolean = false;
  public idBo: string = '0';
  public idBoSource: string = '0';
  public isSaving: boolean = false;
  public isBoReady: boolean = false;

  private defaulInputs: InputModel[] = [];
  public ngOnInit(): void {
  }

  public OnSaveBo(Modal : any): void {

    if (this.isSaving) {
      if (this.fusionStage)
        this.toast.showInfoToast('Fusion de stage en cours');
      else
        this.toast.showInfoToast('Duplication de stage en cours');
      return;
    }
    this.isSaving = true;
    if (this.fusionStage) {      
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' }).result.then((modalResult) => {
        switch (modalResult) {
          case 'SAVE': this.OnBoMerged(); break;
          case 'CANCEL': this.isSaving = false; break;
        }
      });
      //this.OnBoMerged();
    } else {
      this.ParamBOStage.model.IdDonneeFils = '0';
      this.saveBO = true;
    }    
  }

  public OnBoSaved(newBo: BObjectModel): void {

    const mode: string = 'DUPLICATE_STAGE';

    this.idBo = newBo.IdDonneeFils;
    this.modelDuplication.IdentNewStage = newBo.IdDonneeFils;
    this.modelDuplication.IdentOldStage = this.idBoSource;

    if (this.checkBoxes && this.checkBoxes.length > 0)
      this.modelDuplication.BoALier = this.checkBoxes.filter(checkbox => checkbox.Selected).map(checkBox => checkBox.Value);

    this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/StageDuplicationModel/${mode}`, this.modelDuplication).subscribe((result: QResult<boolean>) => {
      this.isSaving = false;
      this.success.emit(!result.HasAlert);
      if (!result.HasAlert) {
        const param: QueovalParam = new QueovalParam();
        this.breadCrumb.Back();
        //this.breadCrumb.call(new BreadcrumbModel('add', `view/formations/stage-detail/${newBo.IdDonneeFils}/vue360`, param, 'Détail stage', false));
      }
    });
  }

  public OnBoMerged(): void {    

    if (this.checkBoxes && this.checkBoxes.length > 0)
      this.modelDuplication.BoALier = this.checkBoxes.filter(checkbox => checkbox.Selected && (!this.fusionStage || (checkbox.Value != 'RESPONSABLE' && checkbox.Value != 'LIEU' && checkbox.Value != 'RESERVE' && checkbox.Value != 'DEPENSE' && checkbox.Value != 'TACHE'))).map(checkBox => checkBox.Value);
   
    let mode: string = 'MERGE_STAGES';
    this.modelDuplication.IdentNewStage = this.fusionStage;
    this.modelDuplication.IdentOldStage = this.idBoSource;
    
    this.http.postHttp<QResult<Array<string>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/StageDuplicationModel/${mode}`, this.modelDuplication).subscribe((result: QResult<Array<string>>) => {
      this.isSaving = false;
      this.success.emit(!result.HasAlert);
      if (!result.HasAlert) {
        const param: QueovalParam = new QueovalParam();        
        this.breadCrumb.Back();
        //this.breadCrumb.call(new BreadcrumbModel('add', `view/formations/stage-detail/${this.modelDuplication.IdentNewStage}/vue360`, param, 'Détail stage', false));
      }
    });
  }


  public OnBoReady(Bo: BObjectModel): void {
    this.isBoReady = true;
    this.ParamBOStage.model = Bo;
    this.ParamBOStage.model.IdDonneeFils = '0';
    this.ParamBOStage.model.DefaultInputs = this.defaulInputs;
    //console.log(this.ParamBOStage.model);
  }
}
